import styled from 'styled-components'

export const ServiceActivationState = styled.div<any>`
  display: flex;
  align-items: center;
  gap: 28px;
  min-height: 220px;
  padding: 36px;
  background: ${({theme}) => theme.grey[100]};
  border: 1px solid ${({theme}) => theme.grey[350]};
  border-radius: 8px;

  @media (max-width: 640px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 20px;
    padding: 24px;
  }
`

export const ServiceActivationBadge = styled.div<any>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 76px;
  width: 76px;
  height: 76px;
  color: ${({theme}) => theme.primary[700]};
  background: ${({theme}) => theme.primary[50]};
  border-radius: 20px;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.5px;
`

export const ServiceActivationContent = styled.div<any>`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  max-width: 620px;
  gap: 12px;

  button {
    margin-top: 8px;
  }
`
